<ppl-two-factor-method-setup-common
  title="Authenticator App Setup"
  i18n-title="@@Authenticator_App_Setup"
  width="550px"
  [step]="step"
  [methodType]="TwoFAType.AUTH_APP"
  [securityToken]="securityToken"
  [getSetupData]="getSetupData"
  [actionDisabled]="actionDisabled"
  [showResendCode]="false"
  [formGroup]="form"
  (nextStep)="onNextStep($event)"
  (cancel)="onCancel()"
  (finish)="onFinish($event)">
  @switch (step) {
    @case (TwoFactorMethodSetupCommonStep.INIT) {
      <ppl-two-factor-method-setup-step
        title="Step 1"
        i18n-title="@@Step_1"
        description="Instead of waiting for text messages, get verification codes for free from the Authenticator app. It works even if your phone is offline."
        i18n-description="@@TwoFactorMethodSetupAuthAppInitDescription">
        <ppl-input-container
          label="Name of your Authenticator app"
          i18n-label="@@Name_of_your_Authenticator_app"
          [bold]="true"
          pplFormControlName="name">
          <input
            pplInput
            type="text"
            autocomplete="name"
            formControlName="name"
            placeholder="My trusted authenticator..."
            i18n-placeholder="@@My_trusted_authenticator..." />
        </ppl-input-container>
      </ppl-two-factor-method-setup-step>
    }
    @case (TwoFactorMethodSetupCommonStep.CUSTOM) {
      <ppl-two-factor-method-setup-step
        title="Step 2"
        i18n-title="@@Step_2"
        [showDescription]="false">
        <ul class="description">
          <li i18n="@@Get_the_Authenticator_App_from_the_App_or_Play_Store.">Get the Authenticator App from the App or Play Store.</li>
          <li i18n="@@In_the_chosen_app_tap_the_Add_icon_+_or_Add_an_Account_option.">In the chosen app tap the Add icon + or Add an Account option.</li>
          <li i18n="@@Choose_to_Scan_a_QR_code_or_Enter_a_setup_key">Choose to Scan a QR code or Enter a setup key</li>
        </ul>
        <div class="qrcode-and-auth-key">
          <div class="box-container">
            <div
              class="box-title"
              i18n="@@Scan_QR_Code">
              Scan QR Code
            </div>
            <div
              #qrCodeContainer
              class="box qrcode-box"></div>
          </div>
          <div class="box-container">
            <div
              class="box-title"
              i18n="@@Can't_Scan?">
              Can't Scan?
            </div>
            <div class="box auth-key-box">
              <div class="auth-key-description">Enter your Coevera CRM login email address and this key into your authenticator app:</div>
              <div class="auth-key">{{ authKeyFormatted }}</div>
            </div>
          </div>
        </div>
      </ppl-two-factor-method-setup-step>
    }
  }
</ppl-two-factor-method-setup-common>
